import React, { FC, memo } from 'react'
import { Section, Title, TitleContainer, TableWrapper, Table, TableRow, TableHeaderCell, TableCell } from './styles'
import { KeyInformationTransport } from '../../../transports/region-landing-page-transport'

interface KeyInformationSectionProps {
    keyInformation: KeyInformationTransport
}

const KeyInformationSection: FC<KeyInformationSectionProps> = ({ keyInformation }) => {
    const { heading, planningOverviewLabel, detailsLabel, items } = keyInformation

    return (
        <Section id="key-information">
            <TitleContainer>{heading && <Title>{heading}</Title>}</TitleContainer>
            <TableWrapper>
                <Table>
                    <thead>
                        <tr>
                            <TableHeaderCell>{planningOverviewLabel}</TableHeaderCell>
                            <TableHeaderCell>{detailsLabel}</TableHeaderCell>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(item => (
                            <TableRow key={item.label}>
                                <TableCell>{item.label}</TableCell>
                                <TableCell>{item.value}</TableCell>
                            </TableRow>
                        ))}
                    </tbody>
                </Table>
            </TableWrapper>
        </Section>
    )
}

export default memo(KeyInformationSection)
